import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';
import { getDefaultDashboard } from '../../utils/roleAccess';
import { useLanguage } from '../../contexts/LanguageContext';

const BackButton = ({ fallback }) => {
  const navigate = useNavigate();
  const { role } = useAuth();
  const { t } = useLanguage();

  const handleBack = () => {
    if (window.history?.length > 1) {
      navigate(-1);
    } else {
      navigate(fallback || getDefaultDashboard(role) || '/');
    }
  };

  return (
    <button
      onClick={handleBack}
      className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors px-2 py-1 rounded-md hover:bg-muted"
      aria-label="Go back"
    >
      <Icon name="ArrowLeft" size={16} />
      <span>{t('back')}</span>
    </button>
  );
};

export default BackButton;
